import { useMemo } from "react";
import { TagCollection } from "../models/TagCollection";
import { FlatVsaaTag } from "../models/VsaaTag";

export interface SearchResult extends FlatVsaaTag {
  collectionTitle: string;
  displayPath: string;
}

export function useTagSearch(
  searchTerm: string,
  allTagsMap: Map<string, FlatVsaaTag[]>,
  tagCollections: TagCollection[]
): { results: SearchResult[] } {
  const results = useMemo<SearchResult[]>(() => {
    if (!searchTerm) return [];

    const term = searchTerm.toLowerCase();
    const allResults: SearchResult[] = [];

    tagCollections.forEach((collection) => {
      const tags = allTagsMap.get(collection.id) ?? [];
      const tagMap = new Map<string, FlatVsaaTag>(tags.map((t) => [t.id, t]));

      tags
        .filter((tag) => tag.title.toLowerCase().startsWith(term))
        .forEach((tag) => {
          const ancestorTitles: string[] = [];
          if (tag.ancestorIds) {
            for (const ancestorId of tag.ancestorIds) {
              const ancestor = tagMap.get(ancestorId);
              if (ancestor) {
                ancestorTitles.push(ancestor.title);
              }
            }
          }

          const pathParts = [collection.title, ...ancestorTitles];
          const displayPath = pathParts.join("/") + "/";

          allResults.push({
            ...tag,
            tagCollectionId: collection.id,
            collectionTitle: collection.title,
            displayPath,
          });
        });
    });

    return allResults;
  }, [searchTerm, tagCollections, allTagsMap]);

  return { results };
}
